// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';

// 🔹 Styled Components
const DownloadContainer = styled.div`
  max-width: 900px;
  margin: auto;
  padding: 20px;
  text-align: center;
  color: #fff;
`;

const DownloadSection = styled.div`
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
`;

const DownloadGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap; /* ✅ Mobile: Items umbrechen */

  @media (max-width: 768px) {
    flex-direction: column; /* ✅ Mobile: Items untereinander */
    align-items: center;
  }
`;

const DownloadItem = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #fff;
  padding: 15px;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const DownloadImage = styled.img`
  width: 150px;
  height: auto;
  object-fit: contain;
  margin-bottom: 10px;

  @media (max-width: 480px) {
    width: 120px; /* ✅ Kleinere Bilder für sehr kleine Displays */
  }
`;

const StyledLine = styled.div`
  border-top: 1px solid #444;
  margin: 10px 0;
`;

const SystemRequirements = styled.div`
  padding: 25px;
  border-radius: 8px;
  margin-top: 30px;
  text-align: center;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  color: #fff;
  text-align: left;

  th,
  td {
    border: 1px solid #444;
    padding: 12px;
  }

  th {
    background-color: #222;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 10px;
      font-size: 12px;
    }
  }
`;


const DownloadURLGDrive = process.env.REACT_APP_CLIENT_DOWNLOAD_GDRIVE_URL;
const DownloadURLMega = process.env.REACT_APP_CLIENT_DOWNLOAD_MEGA_URL;

const DownloadPage = () => {
  const { t } = useTranslation();

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('download.downloadTitle')} />
      <DownloadContainer>
        <p>{t('download.chooseOption')}</p>
        <DownloadSection>
          <h5>{t('download.gameClientDownload')}</h5>
          <DownloadGrid>
            <DownloadItem href={DownloadURLGDrive} target="_blank">
              <DownloadImage src="/assets/download/google-img.svg" alt="Google Drive" />
              <span>{t('download.googleDrive')}</span>
            </DownloadItem>
            <DownloadItem href={DownloadURLMega} target="_blank">
              <DownloadImage src="/assets/download/mega-img.svg" alt="Mega" />
              <span>{t('download.downloadFromMega')}</span>
            </DownloadItem>
          </DownloadGrid>
        </DownloadSection>
        <StyledLine />
        <SystemRequirements>
          <h5>{t('download.systemRequirements')}</h5>
          <Table>
            <thead>
              <tr>
                <th>{t('download.component')}</th>
                <th>{t('download.recommended')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('download.os')}</td>
                <td>{t('download.osRecommended')}</td>
              </tr>
              <tr>
                <td>{t('download.processor')}</td>
                <td>{t('download.processorRecommended')}</td>
              </tr>
              <tr>
                <td>{t('download.memory')}</td>
                <td>{t('download.memoryRecommended')}</td>
              </tr>
              <tr>
                <td>{t('download.graphics')}</td>
                <td>{t('download.graphicsRecommended')}</td>
              </tr>
              <tr>
                <td>{t('download.storage')}</td>
                <td>{t('download.storageRecommended')}</td>
              </tr>
              <tr>
                <td>{t('download.internet')}</td>
                <td>{t('download.internetRecommended')}</td>
              </tr>
            </tbody>
          </Table>
        </SystemRequirements>
      </DownloadContainer>
    </PageContentComponent>
  );
};

export default DownloadPage;
